import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BisectPipe } from './bisect.pipe';

@Pipe({ name: 'bisectAsync' })
export class BisectAsyncPipe implements PipeTransform {
  constructor(private bisectPipe: BisectPipe) {}

  transform<T extends any>(value: Observable<T[]>): Observable<[T[], T[]]> {
    return value.pipe(map(items => this.bisectPipe.transform(items)));
  }
}
